const UAT_HOST_PATTERN = /\.uatbi\.com\.br$/i

export const resolveTrackEnvironment = (): EnvType => {
  if (UAT_HOST_PATTERN.test(window.location.hostname)) {
    return 'staging'
  }

  return (process.env.REACT_APP_ENVIRONMENT ?? process.env.NODE_ENV) as EnvType
}
